import React, { useEffect, useState } from "react";
import KeplerGl from "kepler.gl";
import { addDataToMap } from "kepler.gl/actions";
import { useDispatch } from "react-redux";
import { transformData, filterDataWithCoordinates } from "./Utils/helpers";
import config from "./config";
import { fetchVehicleData } from "./Services/FetchHawkeyeData";
import "./App.css";

function Map() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  useEffect(() => {
    fetchVehicleData(setData, setLoading);
  }, []);

  useEffect(() => {
    if (data) {
      const transformedData = transformData(data);
      const filteredDataIfLatLongExists =
        filterDataWithCoordinates(transformedData);
      dispatch(
        addDataToMap({
          datasets: {
            info: {
              label: "Vehicle Data",
              id: "action",
            },
            data: filteredDataIfLatLongExists,
          },
          option: {
            centerMap: true,
            readOnly: false,
          },
          config,
        })
      );
    }
  }, [dispatch, data]);

  return (
    <>
      {loading ? (
        <>
          <div id="loading-overlay">
            <div id="loading-spinner"></div>
          </div>
        </>
      ) : (
        <></>
      )}

      <KeplerGl
        id="map"
        width={window.innerWidth}
        height={window.innerHeight}
        mapboxApiAccessToken="pk.eyJ1IjoicmFtcmFuYTExIiwiYSI6ImNsbG1uNW1tdDI5enEzanFqNHdkMjEza2sifQ.urTuzpirLxgKrGBQ4hNZ2Q"
      />
    </>
  );
}
export default Map;
